import React from "react";
import { Menu, X } from "lucide-react";
import logo from "../assets/logo-circle-only.png";

const Navbar = ({ scrollTo, isMenuOpen, setIsMenuOpen }) => (
  <header className="fixed top-0 left-0 right-0 z-50 bg-primary shadow-xl border-b border-accent/20">
    <div className="container mx-auto px-4">
      <div className="flex items-center justify-between h-16 md:h-24">
        {/* Branding with Circular Logo Mark */}
        <div
          className="flex items-center gap-2 md:gap-3 cursor-pointer shrink-0"
          onClick={() => scrollTo("home")}
        >
          <div className="h-10 w-10 md:h-14 md:w-14 flex items-center justify-center overflow-hidden">
            {/* Replaced 'IG' text with your circle-only logo mark */}
            <img
              src={logo}
              alt="IndoGlobus Symbol"
              className="h-full w-full object-contain"
            />
          </div>
          <div className="min-w-0">
            <h1 className="text-lg md:text-2xl font-black text-accent tracking-tighter uppercase leading-none truncate">
              IndoGlobus
            </h1>
            <p className="text-[8px] md:text-xs text-white/70 font-bold uppercase tracking-widest mt-0.5 truncate">
              Connecting The World
            </p>
          </div>
        </div>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-6 lg:gap-10">
          {["Home", "About", "Products", "Contact"].map((item) => (
            <button
              key={item}
              onClick={() => scrollTo(item.toLowerCase())}
              className="text-xs lg:text-sm font-bold text-white/90 hover:text-accent transition-all relative group uppercase tracking-widest"
            >
              {item}
              <span className="absolute -bottom-1 left-0 h-0.5 bg-accent transition-all duration-300 w-0 group-hover:w-full"></span>
            </button>
          ))}
        </nav>

        {/* Mobile Toggle */}
        <button
          className="md:hidden text-accent p-2 outline-none"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
        >
          {isMenuOpen ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>
    </div>

    {/* Mobile Menu Overlay */}
    {isMenuOpen && (
      <div className="md:hidden bg-primary border-t border-accent/20 p-6 space-y-4 shadow-2xl animate-in fade-in slide-in-from-top-5">
        {["Home", "About", "Products", "Contact"].map((item) => (
          <button
            key={item}
            onClick={() => scrollTo(item.toLowerCase())}
            className="block text-xl font-bold text-accent border-b border-white/5 pb-2 text-left w-full uppercase"
          >
            {item}
          </button>
        ))}
      </div>
    )}
  </header>
);

export default Navbar;
